﻿/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AsyncThunk,
  AsyncThunkOptions,
  AsyncThunkPayloadCreator,
  configureStore,
  Dispatch,
} from '@reduxjs/toolkit'
import GettingStartedReducer from 'features/GettingStarted/store/GettingStartedReducer'
// import { ConnectionReducer } from 'features/SignalR/store/SignalRStore'
import ConnectionReducer from 'features/SignalR/store/ConnectionReducer'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { reducer as toastrReducer } from 'react-redux-toastr'
import ProjectslistReducer from 'store/ProjectList/NewProjectListReducer'
import newProjectReducer from '../features/BillOfMaterials/store/projectReducer'
import * as App from './Application/appReducer'
import CapabilitiesSettingsReducer from './MachineActions/Reducer'
import materialReducer from './MaterialSelector/MaterialsReducer'
import API from './Middlewares/API'
import SettingsReducer from './Settings/SettingsReducer'
import TenantConfigurationReducer from './Tenant/TenantConfigurationReducer'
import UIReducer from './UI/UIReducer'
import newUserReducer from './User/newUserReducer'

const store = configureStore({
  reducer: {
    project: newProjectReducer,
    // connection: ConnectionReducer,
    connection: ConnectionReducer,
    projectList: ProjectslistReducer,
    user: newUserReducer,
    toastr: toastrReducer,
    materials: materialReducer,
    app: App.appReducer,
    settings: SettingsReducer,
    capabilitiesSettings: CapabilitiesSettingsReducer,
    ui: UIReducer,
    tenant: TenantConfigurationReducer,
    gettingStarted: GettingStartedReducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false,
    }).concat(API)
  },
  devTools: {
    actionsDenylist: [
      'notification/add_notification',
      'app/SetLoadingMessage',
      'connections/SetLatestRequest',
    ],
  },
})

export { store }
export default store

export type RootAppState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootAppState> = useSelector

declare module '@reduxjs/toolkit' {
  /**
   * @see https://stackoverflow.com/questions/64793504/cannot-set-getstate-type-to-rootstate-in-createasyncthunk
   */
  // @ts-ignore - augmenting RTK's existing AsyncThunkConfig
  interface AsyncThunkConfig {
    state?: unknown
    dispatch?: Dispatch
    extra?: unknown
    rejectValue?: unknown
    serializedErrorType?: unknown
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  function createAsyncThunk<
    Returned,
    ThunkArg = void,
    ThunkApiConfig extends AsyncThunkConfig = { state: RootAppState } // here is the magic line
  >(
    typePrefix: string,
    payloadCreator: AsyncThunkPayloadCreator<
      Returned,
      ThunkArg,
      ThunkApiConfig
    >,
    options?: AsyncThunkOptions<ThunkArg, ThunkApiConfig>
  ): AsyncThunk<Returned, ThunkArg, ThunkApiConfig>
}
